import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'unauthenticated',
  imports: [TranslateModule],
  template: `<p>{{ "APP.UNAUTHENTICATED" | translate }}</p>`,
  styleUrl: './unauthenticated.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UnauthenticatedComponent { }
